export const myProdApiUrls = {
    reservationURL: 'https://api.thefeast.ai/reservations/api',
    phpURL: 'https://php-api.easyeat.ai',
    paymentURL: 'https://api.thefeast.ai/payments',
    nestURL: 'https://napi.easyeat.ai',
    reportingURL: 'https://api.thefeast.ai/reporting',
    analyticsURL: 'https://api.thefeast.ai/reporting',
    cmmURL: 'https://api.thefeast.ai/cmm',
    loyaltyURL: 'https://api.thefeast.ai/loyalty'
};

export const idProdApiUrls = {
    reservationURL: 'https://api.thefeast.ai/reservations/api',
    phpURL: 'https://php-api.easyeat.ai',
    paymentURL: 'https://payment-play.easyeat.ai/payments',
    nestURL: 'https://napi.easyeat.id',
    reportingURL: 'https://api.thefeast.ai/id/reporting',
    analyticsURL: 'https://api.thefeast.ai/id/reporting',
    cmmURL: 'https://api.thefeast.ai/cmm',
    loyaltyURL: 'https://api.thefeast.ai/loyalty'
};

export const thProdApiUrls = {
    reservationURL: 'https://api.thefeast.ai/reservations/api',
    phpURL: 'https://api.thefeast.ai',
    paymentURL: 'https://api.thefeast.ai/payments',
    nestURL: 'https://napi.easyeat.ai',
    reportingURL: 'https://api.thefeast.ai/reporting',
    analyticsURL: 'https://api.thefeast.ai/reporting',
    cmmURL: 'https://api.thefeast.ai/cmm',
    loyaltyURL: 'https://api.thefeast.ai/loyalty'
};

export const devApiUrls = {
    reservationURL: 'https://apidev.thefeast.ai/reservations/api',
    phpURL: 'https://apidev.thefeast.ai',
    paymentURL: 'https://apidev.thefeast.ai/payments',
    nestURL: 'https://apidev.thefeast.ai/my',
    reportingURL: 'https://apidev.thefeast.ai/reporting',
    analyticsURL: 'https://apidev.thefeast.ai/reporting',
    cmmURL: 'https://apidev.thefeast.ai/cmm',
    loyaltyURL: 'https://apidev.thefeast.ai/loyalty'
};